import rules from "@/utils/rules";

export const headersForDialog = [
    {
        "text": "Наименование",
        "dataField": "name",
        "typeVar": "input",
        rules: [rules.required, rules.counter3, rules.rus],
        "order": 0,
    },
    {
        "text": "Сокращенное наименование",
        "dataField": "nameShort",
        "typeVar": "input",
        rules: [rules.required, rules.counter3, rules.rus],
        "order": 1,
    },{

        "text": "КПП",
        "dataField": "kpp",
        "typeVar": "input",
        rules: [rules.required, (v) =>  v && v.length === 9 || 'не правильный КПП'],
        "order": 1,
    },{

        "text": "Адрес",
        "dataField": "address",
        "typeVar": "input",
        rules: [rules.required],
        "order": 1,
    }
]